<script setup>
import { ref, reactive } from "vue";
import TabNavigation from "../TabNavigation.vue";
import TabContent from "../TabContent.vue";
import CoursePermissionsTab from "@/components/Dashboard/Courses/Course/tabs/CoursePermissionsTab.vue";
import CourseDevicesTab from "@/components/Dashboard/Courses/Course/tabs/CourseDevicesTab.vue";
import CourseRerunRoundsTab from "@/components/Dashboard/Courses/Course/tabs/CourseRerunRoundsTab.vue";

const activeTab = ref("course-permissions-tab");

const tabs = reactive([
  {
    id: "course-permissions-tab",
    href: "#course-permissions",
    controls: "course-permissions",
    label: "Course Permissions",
    isActive: true,
  },
  {
    id: "course-devices-tab",
    href: "#course-devices",
    controls: "course-devices",
    label: "Devices",
    isActive: false,
  },
  {
    id: "rerun-rounds-tab",
    href: "#rerun-rounds",
    controls: "rerun-rounds",
    label: "Reruns Rounds",
    isActive: false,
  },
]);

const handleTabClick = (tabId) => {
  tabs.forEach((tab) => {
    tab.isActive = false;
  });
  const tab = tabs.find((t) => t.id === tabId);
  if (tab) {
    tab.isActive = true;
  }
  activeTab.value = tabId;
};
</script>

<template>
  <div class="col-12">
    <div class="card card-primary card-tabs">
      <div class="card-header p-0 pt-1">
        <TabNavigation :tabs="tabs" @tab-click="handleTabClick" />
      </div>
      <div class="card-body">
        <TabContent :tabs="tabs">
          <template #course-permissions-tab>
            <CoursePermissionsTab />
          </template>
          <template #course-devices-tab>
            <CourseDevicesTab />
          </template>
          <template #rerun-rounds-tab>
            <CourseRerunRoundsTab />
          </template>
        </TabContent>
      </div>
    </div>
  </div>
</template>
